import Accordion from '../../accordion/accordion';

const defaults = {
  initialPanel: false,
  triggerClass: 'quality-indicator-list__trigger',
  panelClass: 'quality-indicator-list__toggle'
};

class QualityIndicatorList {
  constructor (element, settings) {
    this.element = element;
    this.options = Object.assign({}, defaults, settings);
    this.indicatorTables = this.element.querySelectorAll(this.options.tableClass);
  }

  init () {
    this.qualityIndicatorInstance = new Accordion(this.element, this.options);
    this.qualityIndicatorInstance.init();
  }
}

export default QualityIndicatorList;
